export const DEFAULT_OFFER = 'no_offer';
export const DEFAULT_PRODUCT = 'no_product';
export const DEFAULT_CTA = 'no_cta';
